import type { Load } from '@sveltejs/kit';
import { openPostInModal, postInModal } from '$src/stores';
import { findPostById } from '$src/utils/api/posts.util';

export const prerender = false;

export const load: Load = async ({ url }) => {
  try {
    const postId = url.searchParams.get('post');
    if (!postId) return;
    const post = await findPostById(postId, 'full');
    openPostInModal.set(true);
    postInModal.set({ post, isLoading: false });

  } catch (e: unknown) {
    if (e instanceof Error) {
      // eslint-disable-next-line no-console
      console.error(`Something went wrong: ${e.stack}`);
      throw new Error(`Something went wrong: ${e.message}`);
    }
  }
};
